/**
 * When a form is loaded, enable any rtes in textareas using Quill.
 */
define('controllers/fieldTextareaRTE',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			this.listenTo( nfRadio.channel( 'textarea' ), 'render:view', this.initTextareaRTEs );
			this.listenTo( nfRadio.channel( 'textarea' ), 'click:extra', this.clickExtra );

			// Instantiates the variable that holds the media library frame.
			this.meta_image_frame;

			this.currentContext = {};
			this.quillInstances = {};

			// Check if Quill is loaded
			if( 'undefined' == typeof Quill ) return;

			// Monkey-patch TableRow.checkMerge to prevent infinite loop on malformed HTML (#7944)
			this.patchTableRowCheckMerge();
		},

		/**
		 * Patch TableRow.checkMerge() to add defensive type checking.
		 * Prevents infinite loop when malformed table HTML creates invalid blot structure.
		 * Fixes issue #7944.
		 */
		patchTableRowCheckMerge: function() {
			var TableRow = Quill.import('formats/table-row');
			if (!TableRow || TableRow._nfCheckMergePatched) {
				return;
			}

			var originalCheckMerge = TableRow.prototype.checkMerge;

			TableRow.prototype.checkMerge = function() {
				// Defensive check: ensure all children have formats() method (are TableCells)
				// If any child is not a proper TableCell, skip the merge to prevent TypeError
				if (!this.children || !this.children.head) {
					return false;
				}
				if (typeof this.children.head.formats !== 'function') {
					return false;
				}
				if (!this.children.tail || typeof this.children.tail.formats !== 'function') {
					return false;
				}
				if (this.next && this.next.children) {
					if (this.next.children.head && typeof this.next.children.head.formats !== 'function') {
						return false;
					}
					if (this.next.children.tail && typeof this.next.children.tail.formats !== 'function') {
						return false;
					}
				}
				return originalCheckMerge.call(this);
			};

			TableRow._nfCheckMergePatched = true;
		},

		initTextareaRTEs: function( view ) {
			if ( 1 != view.model.get( 'textarea_rte' ) ) {
				return false;
			}

			var that = this;
			var fieldEl = jQuery( view.el ).find( '.nf-element' );

			// Hide the original textarea
			fieldEl.hide();

			// Create wrapper and container for Quill
			var instanceId = 'quill-frontend-' + view.model.get('id') + '-' + Date.now();
			var quillWrapper = jQuery('<div class="nf-quill-wrapper" style="clear: both;"></div>');
			var quillContainer = jQuery('<div id="' + instanceId + '"></div>');
			quillWrapper.append(quillContainer);
			fieldEl.after(quillWrapper);

			// Use requestAnimationFrame to ensure DOM is ready
			requestAnimationFrame(function() {
				// Verify element is still in DOM
				if (!jQuery.contains(document, quillContainer[0])) {
					return;
				}

				// Define toolbar
				var toolbarOptions = [
					[{ 'header': [1, 2, 3, false] }],
					['bold', 'italic', 'underline', 'clean'],
					[{ 'list': 'ordered'}, { 'list': 'bullet' }],
					[{ 'align': ['', 'center', 'right', 'justify'] }],
					['nf-link', 'nf-unlink'],
					[{ 'table': 'table' }],
					['nf-undo', 'nf-redo']
				];

				// Add media button if enabled and user is logged in
				if ( 1 == view.model.get( 'textarea_media' ) && 0 != userSettings.uid ) {
					toolbarOptions.push(['nf-media']);
				}

				// Initialize Quill
				var quill = new Quill('#' + instanceId, {
					theme: 'snow',
					modules: {
						toolbar: {
							container: toolbarOptions,
							handlers: {
								'nf-link': function() {
									that.showLinkDialog(quill, view);
								},
								'nf-unlink': function() {
									that.removeLink(quill);
								},
								'nf-media': function() {
									that.openMediaManager(quill, view);
								},
								'nf-undo': function() {
									quill.history.undo();
								},
								'nf-redo': function() {
									quill.history.redo();
								},
								'table': function() {
									that.showTablePicker(quill, view);
								}
							}
						},
						history: {
							delay: 1000,
							maxStack: 50,
							userOnly: true
						},
						table: true
					},
					placeholder: view.model.get( 'placeholder' ) || ''
				});

				// Add clipboard matcher to sanitize table HTML during paste operations (#7944)
				// This runs before Quill's Delta conversion, fixing malformed table structures
				// that would otherwise cause infinite loops in checkMerge()
				quill.clipboard.addMatcher('TABLE', function(node, delta) {
					// Create a temporary container and re-parse the table through our sanitizer
					var wrapper = document.createElement('div');
					wrapper.appendChild(node.cloneNode(true));
					var sanitized = that.normalizeTableHtml(wrapper.innerHTML);

					// If sanitization changed the structure, re-convert
					if (sanitized !== wrapper.innerHTML) {
						var tempContainer = document.createElement('div');
						tempContainer.innerHTML = sanitized;
						// Use Quill's clipboard to convert the sanitized HTML
						return quill.clipboard.convert({ html: sanitized });
					}

					return delta;
				});

				// Set initial content — normalize legacy Summernote tables for Quill compatibility
				var initialValue = view.model.get( 'value' ) || '';
				var hasLegacyTable = that.hasLegacyTables(initialValue);
				var initialLoadPending = true;
				// Store original HTML on the instance so the Convert Now handler can
				// work from the pre-Quill-processing value rather than Quill's DOM. (#8026)
				quill._nfOriginalHtml = initialValue;
				quill.root.innerHTML = that.normalizeTableHtml(initialValue);

				if (hasLegacyTable) {
					that.showLegacyTableNotice(view, quillWrapper, quill);
				}

				// Store instance
				that.quillInstances[instanceId] = {
					quill: quill,
					model: view.model,
					view: view
				};

				// Add dashicons - pass wrapper so it can find toolbar
				that.addDashicons(view, quillWrapper);

				// Sync changes back to model and textarea
				quill.on('text-change', function(delta, oldDelta, source) {
					// Skip the initial text-change fired by innerHTML assignment
					if (initialLoadPending) {
						initialLoadPending = false;
						return;
					}

					var html = quill.root.innerHTML;
					view.model.set( 'value', html );
					fieldEl.val( html );
					fieldEl.trigger( 'change' );
				});

				// Handle right-click context menu for tables
				jQuery(quill.root).on('contextmenu', function(e) {
					that.showTableContextMenu(quill, e);
				});

				// Store reference
				quillContainer.data('quill-instance', instanceId);
			});
		},

		addDashicons: function(view, container) {
			var toolbar = container.find('.ql-toolbar');

			// Replace button content with dashicons
			toolbar.find('.ql-bold').html('<span class="dashicons dashicons-editor-bold"></span>');
			toolbar.find('.ql-italic').html('<span class="dashicons dashicons-editor-italic"></span>');
			toolbar.find('.ql-underline').html('<span class="dashicons dashicons-editor-underline"></span>');
			toolbar.find('.ql-list[value="ordered"]').html('<span class="dashicons dashicons-editor-ol"></span>');
			toolbar.find('.ql-list[value="bullet"]').html('<span class="dashicons dashicons-editor-ul"></span>');
			// Note: Don't replace .ql-align content - it's a dropdown picker that needs its internal structure
			toolbar.find('.ql-clean').html('<span class="dashicons dashicons-editor-removeformatting"></span>');

			// Add custom buttons with dashicons
			toolbar.find('button.ql-nf-link').html('<span class="dashicons dashicons-admin-links"></span>');
			toolbar.find('button.ql-nf-unlink').html('<span class="dashicons dashicons-editor-unlink"></span>');
			toolbar.find('button.ql-nf-media').html('<span class="dashicons dashicons-admin-media"></span>');
			toolbar.find('.ql-table').html('<span class="dashicons dashicons-editor-table"></span>');
			toolbar.find('button.ql-nf-undo').html('<span class="dashicons dashicons-undo"></span>');
			toolbar.find('button.ql-nf-redo').html('<span class="dashicons dashicons-redo"></span>');
		},

		showLinkDialog: function(quill, view) {
			var that = this;
			var range = quill.getSelection(true);
			var text = range ? quill.getText(range.index, range.length) : '';

			// Create link dialog
			var linkDropdown = nfRadio.channel( 'app' ).request( 'get:template', '#tmpl-nf-rte-link-dropdown' );
			var dropdownHtml = linkDropdown({});

			var toolbar = jQuery(view.el).find('.ql-toolbar');
			var existingDropdown = toolbar.find('.nf-link-dropdown');

			if (existingDropdown.length) {
				existingDropdown.remove();
				return;
			}

			var dropdown = jQuery('<div class="nf-link-dropdown" role="dialog"></div>').attr('aria-label', nfi18n.insertLink || 'Insert Link').html(dropdownHtml);
			toolbar.append(dropdown);

			dropdown.find('.link-text').val(text);
			dropdown.find('.link-url').focus();

			// Close link dialog on Escape
			dropdown.on('keydown', function(ev) {
				if (ev.keyCode === 27) {
					ev.preventDefault();
					dropdown.remove();
					quill.focus();
				}
			});

			dropdown.find('.insert-link').on('click', function() {
				var linkText = dropdown.find('.link-text').val();
				var linkUrl = dropdown.find('.link-url').val();
				var newWindow = dropdown.find('.link-new-window').prop('checked');

				if (linkUrl) {
					var format = { link: linkUrl };
					if (newWindow) {
						format.target = '_blank';
					}

					if (range && range.length > 0) {
						quill.formatText(range.index, range.length, format);
					} else if (linkText) {
						quill.insertText(range.index, linkText, format);
						quill.setSelection(range.index + linkText.length);
					}
				}

				dropdown.remove();
			});

			dropdown.find('.cancel-link').on('click', function() {
				dropdown.remove();
			});

			// Store current context
			that.currentContext = { quill: quill, range: range };
		},

		removeLink: function(quill) {
			var range = quill.getSelection();
			if (range) {
				quill.formatText(range.index, range.length, { link: false });
			}
		},

		openMediaManager: function(quill, view) {
			var that = this;
			var range = quill.getSelection(true);

			// Store context
			this.currentContext = { quill: quill, range: range };

			// If the frame already exists, re-open it.
			if ( this.meta_image_frame ) {
				this.meta_image_frame.open();
				return;
			}

			// Sets up the media library frame
			this.meta_image_frame = wp.media.frames.meta_image_frame = wp.media({
				title: nfi18n.fieldTextareaRTESelectAFile,
				button: { text:  'insert' }
			});

			// Runs when an image is selected.
			this.meta_image_frame.on('select', function(){
				// Grabs the attachment selection and creates a JSON representation of the model.
				var media_attachment = that.meta_image_frame.state().get('selection').first().toJSON();
				that.insertMedia( media_attachment );
			});

			// Opens the media library frame.
			this.meta_image_frame.open();
		},

		insertMedia: function( media ) {
			var quill = this.currentContext.quill;
			var range = this.currentContext.range || quill.getSelection(true) || { index: 0 };

			if ( 'image' == media.type ) {
				quill.insertEmbed(range.index, 'image', media.url);
				quill.setSelection(range.index + 1);
			} else {
				var linkText = media.title || media.filename;
				quill.insertText(range.index, linkText, { link: media.url });
				quill.setSelection(range.index + linkText.length);
			}
		},

		hasLegacyTables: function(html) {
			if (html.toLowerCase().indexOf('<table') === -1) {
				return false;
			}
			var tmp = document.createElement('div');
			tmp.innerHTML = html;
			// Any <th> is inherently legacy — Quill only supports <td>
			if (tmp.querySelectorAll('th').length > 0) return true;
			var tds = tmp.querySelectorAll('td');
			for (var i = 0; i < tds.length; i++) {
				if (!tds[i].hasAttribute('data-row')) return true;
			}
			return false;
		},

		showLegacyTableNotice: function(view, container, quill) {
			var that = this;
			var toolbar = container.find('.ql-toolbar');
			var fieldEl = jQuery(view.el).find('.nf-element');
			var notice = jQuery('<div class="nf-legacy-table-notice" role="alert"></div>');
			notice.append(jQuery('<span class="nf-legacy-table-text"></span>').text(nfi18n.tableLegacyNotice));
			notice.append(jQuery('<button type="button" class="nf-convert-table-btn"></button>').text(nfi18n.tableLegacyConvert));
			notice.append(jQuery('<button type="button" class="nf-dismiss-notice"></button>').attr('aria-label', nfi18n.dismiss || 'Dismiss').html('&times;'));

			toolbar.after(notice);

			notice.find('.nf-convert-table-btn').on('click', function() {
				// Use the original HTML (before Quill's MutationObserver processed it).
				// quill.root.innerHTML is unsafe here — Quill may have moved table cell
				// content outside the <table> element during DOM reconciliation. (#8026)
				var originalHtml = quill._nfOriginalHtml || '';
				var normalized = that.normalizeTableHtml(originalHtml);
				view.model.set('value', normalized);
				fieldEl.val(normalized);
				fieldEl.trigger('change');
				// Refresh the editor display with the converted content
				quill._nfOriginalHtml = normalized;
				initialLoadPending = true;
				quill.root.innerHTML = normalized;
				notice.slideUp(function() { notice.remove(); });
			});

			notice.find('.nf-dismiss-notice').on('click', function() {
				notice.slideUp(function() { notice.remove(); });
			});
		},

		normalizeTableHtml: function(html) {
			if (html.toLowerCase().indexOf('<table') === -1) {
				return html;
			}

			var tmp = document.createElement('div');
			tmp.innerHTML = html;

			// === MALFORMED TABLE STRUCTURE FIXES (Issue #7944) ===
			// These fixes prevent Quill's infinite loop by ensuring proper table structure
			// before Quill's DOM parser processes the HTML.

			// 1. Remove text nodes (whitespace/newlines) from inside table structure elements
			// Whitespace between <table> and <td> creates text blots that cause checkMerge() to crash
			var tableElements = tmp.querySelectorAll('table, tbody, thead, tfoot, tr');
			for (var i = 0; i < tableElements.length; i++) {
				var el = tableElements[i];
				var childNodes = Array.prototype.slice.call(el.childNodes);
				for (var j = 0; j < childNodes.length; j++) {
					var child = childNodes[j];
					// Remove text nodes (nodeType 3) and comment nodes (nodeType 8)
					if (child.nodeType === 3 || child.nodeType === 8) {
						el.removeChild(child);
					}
				}
			}

			// 2. Fix orphan <td> elements that are direct children of <table> or <tbody>
			// Wrap them in <tr> elements
			var tables = tmp.querySelectorAll('table');
			for (var i = 0; i < tables.length; i++) {
				var table = tables[i];
				var tbody = table.querySelector('tbody');
				var container = tbody || table;

				var orphanTds = [];
				var children = Array.prototype.slice.call(container.children);
				for (var j = 0; j < children.length; j++) {
					if (children[j].tagName === 'TD' || children[j].tagName === 'TH') {
						orphanTds.push(children[j]);
					}
				}

				// Wrap consecutive orphan TDs in a single TR
				if (orphanTds.length > 0) {
					var tr = document.createElement('tr');
					var firstOrphan = orphanTds[0];
					container.insertBefore(tr, firstOrphan);
					for (var j = 0; j < orphanTds.length; j++) {
						tr.appendChild(orphanTds[j]);
					}
				}
			}

			// 3. Remove orphan <tr> elements that have no <td> children
			// These cause checkMerge() to fail when checking formats()
			var allTrs = tmp.querySelectorAll('tr');
			for (var i = 0; i < allTrs.length; i++) {
				var tr = allTrs[i];
				var hasCells = tr.querySelector('td, th');
				if (!hasCells) {
					tr.parentNode.removeChild(tr);
				}
			}

			// === END MALFORMED TABLE STRUCTURE FIXES ===

			// Convert <th> to <td> (Quill only supports TD), preserving all attributes
			var ths = tmp.querySelectorAll('th');
			for (var i = 0; i < ths.length; i++) {
				var td = document.createElement('td');
				td.innerHTML = ths[i].innerHTML;
				for (var a = 0; a < ths[i].attributes.length; a++) {
					td.setAttribute(ths[i].attributes[a].name, ths[i].attributes[a].value);
				}
				ths[i].parentNode.replaceChild(td, ths[i]);
			}

			// Move <thead> and <tfoot> rows into <tbody> (Quill only supports TBODY)
			var sections = tmp.querySelectorAll('thead, tfoot');
			for (var i = 0; i < sections.length; i++) {
				var table = sections[i].parentNode;
				var tbody = table.querySelector('tbody');
				if (!tbody) {
					tbody = document.createElement('tbody');
					table.appendChild(tbody);
				}
				var rows = sections[i].querySelectorAll('tr');
				var isThead = sections[i].tagName === 'THEAD';
				for (var j = 0; j < rows.length; j++) {
					if (isThead) {
						tbody.insertBefore(rows[j], tbody.firstChild);
					} else {
						tbody.appendChild(rows[j]);
					}
				}
				sections[i].parentNode.removeChild(sections[i]);
			}

			// Ensure every table has a <tbody> wrapper
			var tables = tmp.querySelectorAll('table');
			for (var i = 0; i < tables.length; i++) {
				if (!tables[i].querySelector('tbody')) {
					var tbody = document.createElement('tbody');
					var children = tables[i].children;
					var directTrs = [];
					for (var k = 0; k < children.length; k++) {
						if (children[k].tagName === 'TR') {
							directTrs.push(children[k]);
						}
					}
					for (var k = 0; k < directTrs.length; k++) {
						tbody.appendChild(directTrs[k]);
					}
					tables[i].appendChild(tbody);
				}
			}

			// Remove <caption>, <colgroup>, <col> (unsupported by Quill table blots)
			var unsupported = tmp.querySelectorAll('caption, colgroup, col');
			for (var i = 0; i < unsupported.length; i++) {
				unsupported[i].parentNode.removeChild(unsupported[i]);
			}

			// Add data-row to cells that don't have it (required by Quill table module)
			var trs = tmp.querySelectorAll('tr');
			for (var i = 0; i < trs.length; i++) {
				var cells = trs[i].querySelectorAll('td');
				var existingRowId = null;
				var needsId = false;

				for (var j = 0; j < cells.length; j++) {
					if (cells[j].hasAttribute('data-row')) {
						existingRowId = cells[j].getAttribute('data-row');
					} else {
						needsId = true;
					}
				}

				if (needsId) {
					var rowId = existingRowId || ('row-' + Math.random().toString(36).slice(2, 6));
					for (var j = 0; j < cells.length; j++) {
						if (!cells[j].hasAttribute('data-row')) {
							cells[j].setAttribute('data-row', rowId);
						}
					}
				}
			}

			return tmp.innerHTML;
		},

		showTablePicker: function(quill, view) {
			var range = quill.getSelection(true);
			var toolbar = jQuery(view.el).find('.ql-toolbar');

			// Close any existing picker (handles multi-instance case)
			var existingPicker = jQuery('.nf-table-picker');
			var wasOurs = toolbar.find('.nf-table-picker').length > 0;
			existingPicker.remove();
			jQuery(document).off('mousedown.nfTablePicker keydown.nfTablePicker');

			// Toggle behavior — clicking table button again closes its own picker
			if (wasOurs) {
				return;
			}

			// Build the 10x10 grid
			var maxRows = 10;
			var maxCols = 10;
			var picker = jQuery('<div class="nf-table-picker" role="dialog"></div>').attr('aria-label', nfi18n.tableInsertTable || 'Insert Table');
			var grid = jQuery('<div class="nf-table-grid" role="grid"></div>');
			var label = jQuery('<div class="nf-table-label" aria-live="polite">0 \u00d7 0</div>');

			var gridHtml = '';
			for (var r = 1; r <= maxRows; r++) {
				for (var c = 1; c <= maxCols; c++) {
					var isFirst = (r === 1 && c === 1);
					gridHtml += '<div class="nf-table-cell" role="gridcell" tabindex="' + (isFirst ? '0' : '-1') + '" data-row="' + r + '" data-col="' + c + '" aria-label="' + r + ' \u00d7 ' + c + '"></div>';
				}
			}
			grid.html(gridHtml);

			picker.append(grid);
			picker.append(label);
			toolbar.append(picker);

			// Focus the first cell for keyboard users
			grid.find('.nf-table-cell[data-row="1"][data-col="1"]').focus();

			// Cache grid cells for efficient hover highlighting
			var gridCells = grid[0].querySelectorAll('.nf-table-cell');

			// Highlight cells on hover
			grid.on('mouseover', '.nf-table-cell', function() {
				var row = parseInt(this.dataset.row, 10);
				var col = parseInt(this.dataset.col, 10);
				label.text(row + ' \u00d7 ' + col);

				for (var i = 0; i < gridCells.length; i++) {
					var r = parseInt(gridCells[i].dataset.row, 10);
					var c = parseInt(gridCells[i].dataset.col, 10);
					gridCells[i].classList.toggle('highlight', r <= row && c <= col);
				}
			});

			// Insert table on click
			// Note: Frontend RTE intentionally omits _nfUserHasEdited tracking.
			// Unlike the builder (which has a save/reload cycle where Quill normalization
			// could silently overwrite the data model), the frontend is a one-shot form
			// field with no reload — initialLoadPending is sufficient.
			grid.on('click', '.nf-table-cell', function() {
				var rows = parseInt(this.dataset.row, 10);
				var cols = parseInt(this.dataset.col, 10);

				quill.focus();
				if (range) {
					quill.setSelection(range.index, 0);
				}

				var tableModule = quill.getModule('table');
				if (tableModule) {
					tableModule.insertTable(rows, cols);
				}

				picker.remove();
				jQuery(document).off('mousedown.nfTablePicker keydown.nfTablePicker');
			});

			// Keyboard navigation for grid
			grid.on('keydown', '.nf-table-cell', function(e) {
				var cell = jQuery(this);
				var row = parseInt(cell.data('row'), 10);
				var col = parseInt(cell.data('col'), 10);
				var targetRow = row;
				var targetCol = col;

				switch (e.keyCode) {
					case 37: targetCol = Math.max(1, col - 1); break; // Left
					case 38: targetRow = Math.max(1, row - 1); break; // Up
					case 39: targetCol = Math.min(maxCols, col + 1); break; // Right
					case 40: targetRow = Math.min(maxRows, row + 1); break; // Down
					case 13: // Enter — insert table
						cell.trigger('click');
						return;
					default:
						return; // Let other keys pass through
				}
				e.preventDefault();

				var target = grid.find('.nf-table-cell[data-row="' + targetRow + '"][data-col="' + targetCol + '"]');
				if (target.length) {
					cell.attr('tabindex', '-1');
					target.attr('tabindex', '0').focus();
					// Trigger highlight update
					target.trigger('mouseover');
				}
			});

			// Close on outside click
			setTimeout(function() {
				jQuery(document).on('mousedown.nfTablePicker', function(e) {
					if (!jQuery(e.target).closest('.nf-table-picker, .ql-table').length) {
						picker.remove();
						jQuery(document).off('mousedown.nfTablePicker keydown.nfTablePicker');
					}
				});
			}, 0);

			// Close on ESC
			jQuery(document).on('keydown.nfTablePicker', function(e) {
				if (e.keyCode === 27) {
					picker.remove();
					jQuery(document).off('mousedown.nfTablePicker keydown.nfTablePicker');
					quill.focus();
				}
			});
		},

		showTableContextMenu: function(quill, e) {
			// Remove any existing context menus and their event handlers
			jQuery('.nf-table-context-menu').remove();
			jQuery(document).off('mousedown.nfTableContext');

			// Check if right-click target is inside a table cell
			var td = jQuery(e.target).closest('td, th');
			if (!td.length) return;

			var tableModule = quill.getModule('table');
			if (!tableModule) return;

			e.preventDefault();

			var menuItems = [
				{ label: nfi18n.tableInsertRowAbove, action: 'insertRowAbove' },
				{ label: nfi18n.tableInsertRowBelow, action: 'insertRowBelow' },
				{ separator: true },
				{ label: nfi18n.tableInsertColumnLeft, action: 'insertColumnLeft' },
				{ label: nfi18n.tableInsertColumnRight, action: 'insertColumnRight' },
				{ separator: true },
				{ label: nfi18n.tableDeleteRow, action: 'deleteRow' },
				{ label: nfi18n.tableDeleteColumn, action: 'deleteColumn' },
				{ label: nfi18n.tableDeleteTable, action: 'deleteTable' }
			];

			var menu = jQuery('<div class="nf-table-context-menu" role="menu"></div>');

			menuItems.forEach(function(item, index) {
				if (item.separator) {
					menu.append(jQuery('<div class="nf-table-context-separator" role="separator"></div>'));
				} else {
					var menuItem = jQuery('<div class="nf-table-context-item" role="menuitem" tabindex="-1"></div>').text(item.label);
					menuItem.on('click', function() {
						if (typeof tableModule[item.action] === 'function') {
							tableModule[item.action]();
						}
						menu.remove();
						jQuery(document).off('mousedown.nfTableContext keydown.nfTableContext');
						quill.focus();
					});
					menu.append(menuItem);
				}
			});

			// Position at mouse location
			menu.css({
				left: e.clientX + 'px',
				top: e.clientY + 'px'
			});

			jQuery('body').append(menu);

			// Focus first menu item for keyboard users
			menu.find('.nf-table-context-item').first().focus();

			// Keyboard navigation for context menu
			jQuery(document).on('keydown.nfTableContext', function(ev) {
				var items = menu.find('.nf-table-context-item');
				var focused = menu.find('.nf-table-context-item:focus');
				var idx = items.index(focused);

				switch (ev.keyCode) {
					case 40: // Down arrow
						ev.preventDefault();
						idx = (idx + 1) % items.length;
						items.eq(idx).focus();
						break;
					case 38: // Up arrow
						ev.preventDefault();
						idx = (idx - 1 + items.length) % items.length;
						items.eq(idx).focus();
						break;
					case 13: // Enter
						ev.preventDefault();
						if (focused.length) {
							focused.trigger('click');
						}
						break;
					case 27: // Escape
						ev.preventDefault();
						menu.remove();
						jQuery(document).off('mousedown.nfTableContext keydown.nfTableContext');
						quill.focus();
						break;
				}
			});

			// Close on outside click
			setTimeout(function() {
				jQuery(document).on('mousedown.nfTableContext', function(ev) {
					if (!jQuery(ev.target).closest('.nf-table-context-menu').length) {
						menu.remove();
						jQuery(document).off('mousedown.nfTableContext keydown.nfTableContext');
					}
				});
			}, 0);
		},

		clickExtra: function( e ) {
			// Handle extra click events (like insert link button)
			var textEl = jQuery( e.target ).parent().find( '.link-text' );
			var urlEl = jQuery( e.target ).parent().find( '.link-url' );
			var isNewWindowEl = jQuery( e.target ).parent().find( '.link-new-window' );

			if ( jQuery( e.target ).hasClass( 'insert-link' ) ) {
				var text = textEl.val();
				var url = urlEl.val();
				var isNewWindow = ( isNewWindowEl.prop( 'checked' ) ) ? true: false;

				if ( 0 != text.length && 0 != url.length && this.currentContext.quill ) {
					var quill = this.currentContext.quill;
					var range = this.currentContext.range || quill.getSelection(true) || { index: 0 };

					var format = { link: url };
					if (isNewWindow) {
						format.target = '_blank';
					}

					quill.insertText(range.index, text, format);
					quill.setSelection(range.index + text.length);
				}
			}

			textEl.val( '' );
			urlEl.val( '' );
			isNewWindowEl.prop( 'checked', false );
			jQuery( e.target ).closest( '.nf-link-dropdown' ).remove();
		}
	});

	return controller;
} );

